const React = require("react");
const { AdminInventorySourceResource } = require("../components/AdminInventorySourceResource");
const h = React.createElement;
const AdminInventorySourceSuppliers = () => h(AdminInventorySourceResource, { title: "InventorySource suppliers", loader: "getAdminSuppliers", collection: "suppliers", columns: [{ key: "name", label: "Supplier" }, { key: "country", label: "Country" }, { key: "totalProducts", label: "Products" }, { key: "status", label: "Status" }] });
module.exports = { AdminInventorySourceSuppliers };
